import { NavBar } from "../../organisms/NavBar/NavBar";
import {Typography, Box, useTheme} from "@mui/material";
import {Label} from "@mui/icons-material";

export const TutorialsPage = () => {

    const theme = useTheme();

    return (
        <>
            <NavBar />
            <Box
                pl={3.5}
                pr={3.5}
                mt={2}
            >
                <Typography
                    component="p"
                    variant="h6"
                    align="center"
                    color={theme.palette.grey[500]}
                    fontWeight={100}
                >
                    Picks & Tutorials
                </Typography>
                <Typography
                    component="p"
                    variant="body2"
                    align="center"
                >
                    Check out these short videos showcasing picks for upcoming games, along with tutorials on Trend-Spotting’s features.
                </Typography>
            </Box>
            <Box
                display="flex"
                justifyContent="center"
                mt={2}
                pl={3.5}
                pr={3.5}
            >
                <Box
                    display="flex"
                    flexDirection="column"
                    alignContent="center"
                >
                    <Typography
                        variant="caption"
                        align="center"
                        color={theme.palette.grey[500]}
                    >
                        Using trend-finder: Memphis vs Colorado State NCAA Tournament (3/22/2025)
                    </Typography>
                    <iframe
                        width="448"
                        height="252"
                        src="https://www.youtube.com/embed/pM6_feyvNPM"
                        title="YouTube video player"
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                    />
                    <Typography
                        variant="caption"
                        align="center"
                        color={theme.palette.grey[500]}
                        mt={3}
                    >
                        Using trend-finder: Thunder vs Nuggets Selection (3/9/2025)
                    </Typography>
                    <iframe
                        width="448"
                        height="252"
                        src="https://www.youtube.com/embed/rsN_jG90uuE"
                        title="YouTube video player"
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                    />
                    <Typography
                        variant="caption"
                        align="center"
                        color={theme.palette.grey[500]}
                        mt={3}
                    >
                        Using trend-finder: Celtics vs Lakers Selection (3/8/25)
                    </Typography>
                    <iframe
                        width="448"
                        height="252"
                        src="https://www.youtube.com/embed/RgVXX8NTI90"
                        title="YouTube video player"
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                    />
                    <Typography
                        variant="caption"
                        align="center"
                        color={theme.palette.grey[500]}
                        mt={3}
                    >
                        Using trend-finder: Heat vs Timberwolves Selection (3/7/25)
                    </Typography>
                    <iframe
                        width="448"
                        height="252"
                        src="https://www.youtube.com/embed/Ep5EmLs4rq0"
                        title="YouTube video player"
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                    />
                    <Typography
                        variant="caption"
                        align="center"
                        color={theme.palette.grey[500]}
                        mt={3}
                    >
                        Using Active Trends: Lakers vs Knicks Selection (3/6/25)
                    </Typography>
                    <iframe
                        width="448"
                        height="252"
                        src="https://www.youtube.com/embed/G_zW6A40sQA"
                        title="YouTube video player"
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                    />
                </Box>
            </Box>
        </>
    );
};

